enum Endpoint {
    // BASE_URL = 'https://apiiwari.globoazul.pe/1.0/',
    BASE_URL = 'http://iwari-api.com/1.0/',
}

export default Endpoint;
